import React from 'react';
import { connect } from 'react-redux';
import { VolunteerFormView } from '../../';
import './styles.scss';
import { modalViewGA } from '../../../utils/googleAnalytics';

class VolunteerComponent extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal(e) {
    e.preventDefault();
    this.props.removeModal();
  }

  componentDidMount() {
    modalViewGA('volunteer');
  }

  render() {
    return (
      <div>
        <div className="modals-popup contact-us-modal">
          <div className="modal-header d-flex align-items-center">
            <div className="col">Volunteer Opportunities</div>
            <div className="text-right">
              <a className="closer" href="#" onClick={(e)=>{this.closeModal(e)}}></a>
            </div>
          </div>

          <div className="info d-flex">
            <div className="login-form col">
              <div className="bottom">
                <p className="note">
                  If you are a nature and wildlife lover who enjoys these cameras everyday, we have a few
                  volunteer opportunities for great team players. Please check an option and a member of our
                  team will respond as soon as possible.
                </p>
                <VolunteerFormView removeModal={this.props.removeModal} />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {};
}

export default connect(mapStateToProps)(VolunteerComponent);
